import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['source', 'copyButton'];

  copy() {
    navigator.clipboard.writeText(this.codesText)
      .then(() => this.showCopied())
      .catch(() => this.fallbackToManualSelection())
  }

  // navigator.clipboard.writeText can reject for reasons outside our control
  // (e.g. the document losing focus right before the click registers) --
  // silently doing nothing in that case looks exactly like a broken button,
  // so fall back to selecting the codes for the user to copy manually.
  fallbackToManualSelection() {
    const range = document.createRange()
    range.selectNodeContents(this.sourceTarget)
    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)

    const originalLabel = this.copyButtonTarget.innerText
    this.copyButtonTarget.innerText = 'Selected -- press Ctrl+C to copy'
    setTimeout(() => { this.copyButtonTarget.innerText = originalLabel }, 3000)
  }

  download() {
    const blob = new Blob([this.codesText], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'backup-codes.txt'
    link.click()

    URL.revokeObjectURL(url)
  }

  showCopied() {
    const originalLabel = this.copyButtonTarget.innerText
    this.copyButtonTarget.innerText = 'Copied!'
    setTimeout(() => { this.copyButtonTarget.innerText = originalLabel }, 2000)
  }

  get codesText() {
    return this.sourceTarget.innerText
  }
}
